import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import YoutubePlay from '@elem/SVGIcon/OutdoorRecreation/YoutubePlay';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function P() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('loadshedding');
    const { locale } = useRouter();
    const [source, setSource] = useState('');
    const [gap, setGap] = useState(24);
    const LOCAL_SITES: string[] = [''];
    // https://www.youtube.com/watch?v=F_To4UsRO3k"
    const cards: any = [
        {
            img: '/responsive/picture/load-shedding/9_1',
            text: t('secP_list1'),
            video: (() => {
                const map: any = {
                    za: 'https://www.youtube.com/embed/OR5J_UtrX3I?si=A15FM8dj_Av82yDO',
                };
                return map[locale] || map.za;
            })(),
        },
        {
            img: '/responsive/picture/load-shedding/9_2',
            text: t('secP_list2'),
            video: (() => {
                const map: any = {
                    za: 'https://www.youtube.com/embed/nZ6BtoRvyBY?si=TNG8cmy5ZCJahU3_',
                };
                return map[locale] || map.za;
            })(),
        },
        {
            img: '/responsive/picture/load-shedding/9_3',
            text: t('secP_list3'),
            video: (() => {
                const map: any = {
                    za: 'https://www.youtube.com/embed/P4ZE7wb7x9U?si=JdwBXtVkVCKtmUvr',
                };
                return map[locale] || map.za;
            })(),
        },
        {
            img: '/responsive/picture/load-shedding/9_4',
            text: t('secP_list4'),
            video: (() => {
                const map: any = {
                    za: 'https://www.youtube.com/embed/wZ9dU4frkpg?si=HN9FY_RXNIy6GDEd',
                };
                return map[locale] || map.za;
            })(),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="load-shedding-P" className={`load-shedding-P ${css['load-shedding-P']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <h2 className="title">{t('secP_title')}</h2>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={gap}
                    // centeredSlides={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {cards?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k} onClick={() => setSource(card?.video)}>
                            <EFPicture src={`${card?.img}${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`} alt={card?.text} />
                            <YoutubePlay className="youtube-icon" />
                            <div className="card-text-box">
                                <p className="card-text">{card?.text}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {Object.keys(source)?.length > 0 && (
                <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
            )}
        </div>
    );
}
